import React from "react";
import { UserSearch } from "../../components/userSearch";
import { addressData } from "../../components/addAddress/addressData";
import AddressBlock from "../../components/addAddress/addressBlock";
import OrderSummary from "../../components/menu/orderSummary";

export const PendingPayment = () => {
  return (
    
      <div >
        <OrderSummary showPendingPayment={true} buttonText="Resend Payment Link" />
      </div>
  
  );
};
